<template>
  <section class="code-block-v2">
    <code ref="code" v-selection v-dompurify-html="content" />
    <button class="code-block-v2__copy-button" @click="copyContent">
      {{ buttonText }}
      <i :class="buttonIcon" />
    </button>
  </section>
</template>

<script>
import selection from '@/directives/selection';

const COPY_ICON = 'el-icon-copy-document';
const SUCCESS_ICON = 'el-icon-check';
const COPY_TEXT = 'Copy';
const SUCCESS_TEXT = 'Copied';

export default {
  name: 'CodeBlock',
  directives: { selection },
  props: {
    title: {
      type: String,
      default: '',
    },
    content: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      buttonIcon: COPY_ICON,
      buttonText: COPY_TEXT,
    };
  },
  methods: {
    async copyContent() {
      if (!this.$refs.code) return;
      const text = this.$refs.code.innerText;

      if (text) {
        await navigator.clipboard.writeText(text);
        this.showCopySuccessInButton();
      }
    },
    showCopySuccessInButton() {
      this.buttonIcon = SUCCESS_ICON;
      this.buttonText = SUCCESS_TEXT;

      setTimeout(() => {
        this.buttonIcon = COPY_ICON;
        this.buttonText = COPY_TEXT;
      }, 1000);
    },
  },
};
</script>

<style lang="scss">
.code-block-v2 {
  background-color: #eee;
  border: 1px solid #ddd;
  border-radius: 4px;
  padding: $global-padding * 0.5;

  &__copy-button {
    padding: 0.4rem;
    font-size: 0.8rem;
    border: 1px solid #ddd;
    cursor: pointer;
    background: $lb-medium-gray;
    color: $lb-medium-black;
    border-radius: 4px;
    -webkit-backface-visibility: hidden;
    -moz-backface-visibility: hidden;
    -ms-backface-visibility: hidden;
    backface-visibility: hidden;

    &:hover {
      background-color: color.scale($lb-medium-gray, $lightness: -5%);
    }

    &:active {
      transform: scale(0.95);
    }
  }

  code {
    display: block;
    cursor: pointer;
    border: none;
    font-family: $lb-font-family-monospace;
    color: inherit;
    background-color: transparent;
    direction: ltr;

    overflow-x: auto;
    overflow-y: hidden;
    -webkit-overflow-scrolling: touch;
    -ms-overflow-style: -ms-autohiding-scrollbar;

    @include breakpoint(medium) {
      overflow: visible;
      white-space: normal;
      overflow-wrap: break-word;
    }
  }
}
</style>
